import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { collectError } from 'utils';

import { extendFxJwtToken } from '../../../../api/fx';
import { getSuccessLoginUrl } from '../../../../api/cx';
import { loginToOrganisation } from '../../shared/loginToOrganisation';
import type { Organisation } from '../../../../api/types';
import MemberOrganisationsForm from '../../components/MemberOrganisationsForm';

interface MemberOrganisationsProps {
    organisations: Organisation[];
    organisationsIds: string[];
    setOrganisations: (organisation: Organisation[]) => void;
}

const MemberOrganisations: React.FC<MemberOrganisationsProps> = ({
    organisations,
    setOrganisations,
    organisationsIds,
}) => {
    const [formError, setFormError] = useState<string | null>(null);
    const [isFormLoading, setIsFormLoading] = useState(false);
    const { t } = useTranslation();

    const onSubmit = async (e: React.SubmitEvent<HTMLFormElement>): Promise<void> => {
        e.preventDefault();
        const input = e.currentTarget.elements?.namedItem('organisationId') as HTMLInputElement | null;
        const value = input?.value ?? '';

        if (!value) {
            return setFormError(t('Choose an action please'));
        }

        try {
            setIsFormLoading(true);
            const [{ redirectUrl }] = await Promise.all([getSuccessLoginUrl(value), extendFxJwtToken(value)]);

            globalThis.location.assign(redirectUrl);
        } catch (error: unknown) {
            collectError(error);
            setFormError(error as string);
        } finally {
            setIsFormLoading(false);
        }
    };

    useEffect(() => {
        if (organisations.length) {
            return;
        }
        void (async () => {
            try {
                await loginToOrganisation(setOrganisations, organisationsIds);
            } catch (error: unknown) {
                collectError(error);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return organisations.length ? (
        <MemberOrganisationsForm
            onSubmit={e => {
                void onSubmit(e);
            }}
            isLoading={isFormLoading}
            options={organisations}
            formError={formError}
        />
    ) : null;
};

export default MemberOrganisations;
